import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink, RouterModule } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { ScrollerSectionType01Component } from "../../../../modules/client/scroller-section/scroller_section-type01/scroller_section-type01.component";
import { BannerSectionType01Component } from "../../../../modules/client/banner-section/banner_section-type01/banner_section-type01.component";
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChangeGameType01Component } from "../../../../modules/client/change-game/change-game-type01/change-game-type01.component";

@Component({
  selector: 'app-rewards',
  standalone: true,
  imports: [MatIconModule, RouterModule, RouterLink, ScrollerSectionType01Component, BannerSectionType01Component, MatIconModule, MatTooltipModule, ChangeGameType01Component],
  templateUrl: './rewards.component.html',
  styleUrl: './rewards.component.scss'
})
export class RewardsComponent implements OnInit {

  public view: any = {
    title: 'Rewards',
    page: {}
  }

  constructor(public _tfmService: TFMService, private _cd: ChangeDetectorRef, private route: ActivatedRoute){

  }

  ngOnInit(): void {
    this.view.features = [];
    this.view.features.push({icon:"heroicons_outline:ticket", title:"Exclusive Discounts", text:"Exclusive Discounts on flights, hotels, and vacation packages for loyal customers."});
    this.view.features.push({icon:"mat_outline:king_bed", title:"Free Upgrades", text:"Free Upgrades to premium seating, room categories, or vehicle rentals for frequent travelers."});
    this.view.features.push({icon:"hourglass_top", title:"Early Access", text:"Early Access to special promotions, limited-time offers, and new destination launches."});
    this.view.features.push({icon:"heroicons_outline:calendar-days", title:"Priority Booking", text:"Priority Booking during peak travel seasons or for high-demand tours and experiences."});
    this.view.features.push({icon:"feather:shield", title:"Travel Insurance", text:"Complimentary Travel Insurance for eligible bookings or high-tier loyalty members."});
    this.view.features.push({icon:"heroicons_outline:building-storefront", title:"VIP Lounge Access", text:"VIP Lounge Access at select airports for premium members or high-value bookings."});
  }
}
